import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import "./StudentReviewsSection.css";
import reviewBanner from "../../assets/Institute/Colage jpg (1).jpg";

const reviews = [
  {
    name: "Ananya Sharma",
    role: "Nursery Teacher Training, Batch 2023",
    review:
      "NIECCE truly shaped my teaching career! The Montessori-integrated approach and interactive sessions helped me gain deep practical insights. Highly recommend it to every aspiring teacher.",
    rating: 5,
  },
  {
    name: "Deepa Krishnan",
    role: "Montessori Training, Batch 2022",
    review:
      "The faculty is so encouraging! The hands-on learning and exposure to real classroom environments gave me the confidence to start my own preschool journey.",
    rating: 5,
  },
  {
    name: "Kavitha Rao",
    role: "Primary Teacher Training, Batch 2021",
    review:
      "I loved how professional and well-structured the courses are. NIECCE helped me balance theory with practical application — exactly what teachers need today.",
    rating: 5,
  },
  {
    name: "Priya Nair",
    role: "Pre-Primary Course, Batch 2020",
    review:
      "From soft skills to classroom management, NIECCE’s curriculum covers everything. Their placement assistance helped me get my first teaching job right after graduation.",
    rating: 5,
  },
  {
    name: "Divya Menon",
    role: "Montessori Diploma, Batch 2019",
    review:
      "The trainers at NIECCE bring years of expertise and real-world teaching experience. Their guidance made the entire journey enjoyable and highly rewarding.",
    rating: 5,
  },
  {
    name: "Sahana Reddy",
    role: "Online & Regular Batches, Batch 2023",
    review:
      "What I loved most was the flexibility — online and regular options allowed me to complete my course while managing my family responsibilities. Truly learner-friendly!",
    rating: 5,
  },
];

const StudentReviewsSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <section className="reviews-section">
      <div className="container">
        <motion.h2
          className="reviews-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Student Reviews
        </motion.h2>

        <motion.div
          className="reviews-banner"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        >
          <img
            src={reviewBanner}
            alt="NIECCE teacher training students"
            title="NIECCE teacher training students"
          />
        </motion.div>

        <Slider {...settings} className="reviews-slider">
          {reviews.map((r, index) => (
            <motion.div
              key={index}
              className="review-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.2 }}
            >
              <FaQuoteLeft className="quote-icon" />
              <p className="review-text">“{r.review}”</p>
              <div className="review-stars">
                {Array(r.rating)
                  .fill()
                  .map((_, i) => (
                    <FaStar key={i} />
                  ))}
              </div>
              <h4 className="review-name">{r.name}</h4>
              <p className="review-role">{r.role}</p>
            </motion.div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default StudentReviewsSection;
